import { createAction } from 'redux-actions';
import { SET_KEYCLOAK } from './constants';

export const setKeycloak = createAction(SET_KEYCLOAK, (payload: any) => payload);



